import { Atoms, Box } from '@dropbox/dig-foundations';
import { useAtomValue } from 'jotai';
import React, { useMemo, type PropsWithChildren } from 'react';
import { accessibleViewAtom } from 'signer-app/signer-signature-document/accessible-document-toggle';
import { useShouldShowDrawer } from 'signer-app/utils/use-should-show-drawer';

export const SignerBannersWrapper = ({ children }: PropsWithChildren<{}>) => {
  const isFormView = useAtomValue(accessibleViewAtom);
  const isShowingDrawer = useShouldShowDrawer();

  const bannerPaddingRight: Atoms['paddingRight'] = useMemo(() => {
    if (isFormView) {
      return {
        medium: 'Micro XLarge',
        small: 'Micro Large',
        xsmall: 'Micro Small',
      };
    }
    if (isShowingDrawer) {
      return 'Micro Small';
    }
    return {
      medium: 'Micro XLarge',
      small: 'Micro Large',
      xsmall: 'Micro Small',
    };
  }, [isFormView, isShowingDrawer]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      position="absolute"
      top="0"
      width="100%"
      style={{ zIndex: 1 }}
      paddingTop="Micro Small"
      paddingLeft="Micro Small"
      paddingRight={bannerPaddingRight}
      rowGap="Micro Small"
    >
      {children}
    </Box>
  );
};
